import {
  Modal,
  SpaceBetween,
  Table,
} from "@cloudscape-design/components-themed";
import { CODE_MASTER, DivisionDict } from "../default-constants";
import { isEqual } from "lodash";
import { LABELS } from "./constants";

interface IApplicationFormTypeModal {
  visible: boolean;
  onClose: () => void;
  items: DivisionDict[];
}

const ApplicationFormTypeModal = (props: IApplicationFormTypeModal) => {
  const { visible, onClose, items } = props;
  const APPLICATION_FORM_TYPE = CODE_MASTER["APPLICATION_FORM_TYPE"];
  const descriptionList = items.map((item) => {
    const formType = APPLICATION_FORM_TYPE.find((type) =>
      isEqual(type.value, item.value)
    );

    return {
      ...item,
      value: `${item.label}：【d払い（バーコード決済）】${item.label}_${
        formType?.label ?? ""
      }`,
    };
  });

  return (
    <Modal
      visible={visible}
      onDismiss={onClose}
      size="large"
      header={LABELS.APPLICATION_FORM_TYPE_LIST}
    >
      <SpaceBetween direction="horizontal" size="xl">
        <Table
          variant="embedded"
          columnDefinitions={[
            {
              id: "applicationFormType",
              header: "",
              cell: (item) => item.value,
            },
          ]}
          items={descriptionList}
          stickyHeader={false}
        />
      </SpaceBetween>
    </Modal>
  );
};

export default ApplicationFormTypeModal;
